<template>
	<footer class="footer">
		<div class="container">


			<div class="copyright">
				<b>&copy; {{ new Date().getFullYear() }}</b> <b><span class="text-primary"> ONE & ME EXPRESS</span></b>
			</div>
			<div class="copyright text-center">
				Developed by <span class="text-primary"><a href="tel:+855885585543"><b>Traware Technologies</b></a></span>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Layout/ContentFooter.vue